import React from 'react';
import { Space, Tag, Tooltip, Typography } from 'antd';
import type { GenerationRunToolCall } from '../../types';
import { formatCurrency, formatProviderCount, getProviderMeta } from './providerMeta';

const { Text } = Typography;

interface ToolCallCounterProps {
  toolCalls?: GenerationRunToolCall[];
}

const ToolCallCounter: React.FC<ToolCallCounterProps> = ({ toolCalls = [] }) => {
  if (!toolCalls.length) {
    return <Text type="secondary">No tool calls recorded</Text>;
  }

  return (
    <Space wrap size={[8, 8]}>
      {toolCalls.map((toolCall, index) => {
        const meta = getProviderMeta(toolCall.provider);
        const label = toolCall.label || formatProviderCount(toolCall.provider, toolCall.count);
        return (
          <Tooltip
            key={`${toolCall.provider}-${toolCall.phase || 'all'}-${index}`}
            title={`${meta.description}${typeof toolCall.cost_usd === 'number' ? ` · ${formatCurrency(toolCall.cost_usd)}` : ''}`}
          >
            <Tag color={meta.color} style={{ paddingInline: 10, borderRadius: 999 }}>
              <Space size={6}>
                {meta.icon}
                <span>{label}</span>
              </Space>
            </Tag>
          </Tooltip>
        );
      })}
    </Space>
  );
};

export default ToolCallCounter;
